import { DisplaySetSelector, MatchingRule } from '@core/types';

const priorStudyMatchingRules = [
	{
		// The priorInstance is a study counter that indicates what position this study is in
		// and the value comes from the options parameter.
		attribute: 'studyInstanceUIDsIndex',
		from: 'options',
		required: true,
		constraint: {
			equals: { value: 1 }
		}
	}
];

const currentStudyMatchingRules = [
	{
		// The priorInstance is a study counter that indicates what position this study is in
		// and the value comes from the options parameter.
		attribute: 'studyInstanceUIDsIndex',
		from: 'options',
		required: true,
		constraint: {
			equals: { value: 0 }
		}
	}
];

const matchingRuleRCC2D: MatchingRule = {
	weight: 50,
	attribute: 'MammoImageType',
	constraint: {
		equals: 'R-CC-2D'
	},
	required: true
};

const matchingRuleLCC2D: MatchingRule = {
	weight: 50,
	attribute: 'MammoImageType',
	constraint: {
		equals: 'L-CC-2D'
	},
	required: true
};

const matchingRuleRMLO2D: MatchingRule = {
	weight: 50,
	attribute: 'MammoImageType',
	constraint: {
		equals: 'R-MLO-2D'
	},
	required: true
};

const matchingRuleLMLO2D: MatchingRule = {
	weight: 50,
	attribute: 'MammoImageType',
	constraint: {
		equals: 'L-MLO-2D'
	},
	required: true
};

const matchingRuleRCC3D: MatchingRule = {
	weight: 50,
	attribute: 'MammoImageType',
	constraint: {
		equals: 'R-CC-3D'
	},
	required: true
};

const matchingRuleLCC3D: MatchingRule = {
	weight: 50,
	attribute: 'MammoImageType',
	constraint: {
		equals: 'L-CC-3D'
	},
	required: true
};

const matchingRuleRMLO3D: MatchingRule = {
	weight: 50,
	attribute: 'MammoImageType',
	constraint: {
		equals: 'R-MLO-3D'
	},
	required: true
};

const matchingRuleLMLO3D: MatchingRule = {
	weight: 50,
	attribute: 'MammoImageType',
	constraint: {
		equals: 'L-MLO-3D'
	},
	required: true
};

const LCCSeriesMatchingRules: MatchingRule[] = [matchingRuleLCC2D];

const TomoLCCSeriesMatchingRules: MatchingRule[] = [matchingRuleLCC3D];

const RCCSeriesMatchingRules: MatchingRule[] = [matchingRuleRCC2D];

const TomoRCCSeriesMatchingRules: MatchingRule[] = [matchingRuleRCC3D];

const LMLOSeriesMatchingRules: MatchingRule[] = [matchingRuleLMLO2D];

const TomoLMLOSeriesMatchingRules: MatchingRule[] = [matchingRuleLMLO3D];

const RMLOSeriesMatchingRules: MatchingRule[] = [matchingRuleRMLO2D];

const TomoRMLOSeriesMatchingRules: MatchingRule[] = [matchingRuleRMLO3D];

const RCC: DisplaySetSelector = {
	seriesMatchingRules: RCCSeriesMatchingRules,
	studyMatchingRules: currentStudyMatchingRules
};

const TomoRCC: DisplaySetSelector = {
	seriesMatchingRules: TomoRCCSeriesMatchingRules,
	studyMatchingRules: currentStudyMatchingRules
};

const RCCPrior: DisplaySetSelector = {
	seriesMatchingRules: RCCSeriesMatchingRules,
	studyMatchingRules: priorStudyMatchingRules
};

const LCC: DisplaySetSelector = {
	seriesMatchingRules: LCCSeriesMatchingRules,
	studyMatchingRules: currentStudyMatchingRules
};

const TomoLCC: DisplaySetSelector = {
	seriesMatchingRules: TomoLCCSeriesMatchingRules,
	studyMatchingRules: currentStudyMatchingRules
};

const LCCPrior: DisplaySetSelector = {
	seriesMatchingRules: LCCSeriesMatchingRules,
	studyMatchingRules: priorStudyMatchingRules
};

const RMLO: DisplaySetSelector = {
	seriesMatchingRules: RMLOSeriesMatchingRules,
	studyMatchingRules: currentStudyMatchingRules
};

const TomoRMLO: DisplaySetSelector = {
	seriesMatchingRules: TomoRMLOSeriesMatchingRules,
	studyMatchingRules: currentStudyMatchingRules
};

const RMLOPrior: DisplaySetSelector = {
	seriesMatchingRules: RMLOSeriesMatchingRules,
	studyMatchingRules: priorStudyMatchingRules
};

const LMLO: DisplaySetSelector = {
	seriesMatchingRules: LMLOSeriesMatchingRules,
	studyMatchingRules: currentStudyMatchingRules
};

const TomoLMLO: DisplaySetSelector = {
	seriesMatchingRules: TomoLMLOSeriesMatchingRules,
	studyMatchingRules: currentStudyMatchingRules
};

const LMLOPrior: DisplaySetSelector = {
	seriesMatchingRules: LMLOSeriesMatchingRules,
	studyMatchingRules: priorStudyMatchingRules
};

export { LCC, LCCPrior, LMLO, LMLOPrior, RCC, RCCPrior, RMLO, RMLOPrior, TomoLCC, TomoLMLO, TomoRCC, TomoRMLO };
